import { render, staticRenderFns } from "./vehicleBackup.vue?vue&type=template&id=57651ef2"
import script from "./vehicleBackup.vue?vue&type=script&lang=js"
export * from "./vehicleBackup.vue?vue&type=script&lang=js"
import style0 from "./vehicleBackup.vue?vue&type=style&index=0&id=57651ef2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports